import { apiFetch } from './apiFetch';
import { updateProductOption } from './productEditor';

export const uploadProductMedia = async (apiUrl, file) => {
  const body = new FormData();
  body.append('image', file);
  const controller = new AbortController();
  let didTimeout = false;
  const timeout = setTimeout(() => {
    didTimeout = true;
    controller.abort();
  }, 20000);
  let response;
  try {
    response = await apiFetch(`${apiUrl}/api/product-media/upload`, {
      method: 'POST',
      body,
      signal: controller.signal,
    });
  } catch (error) {
    if (!didTimeout) throw error;
    const timeoutError = new Error('O envio da imagem excedeu o tempo limite. Tente novamente.');
    timeoutError.name = 'TimeoutError';
    throw timeoutError;
  } finally {
    clearTimeout(timeout);
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false || !data.asset?.url) {
    throw new Error(data.error || 'Falha ao enviar a imagem do produto.');
  }
  return data.asset;
};

export const prepareProductMediaUploads = async (draft = {}, uploader) => {
  const jobs = [];
  if (draft._pendingImageFile) jobs.push({ type: 'product', file: draft._pendingImageFile });
  (draft.itemOptionGroups || []).forEach((group, groupIndex) => {
    (group.options || []).forEach((option, optionIndex) => {
      if (option._pendingImageFile) jobs.push({ type: 'option', groupIndex, optionIndex, file: option._pendingImageFile });
    });
  });
  if (!jobs.length) return draft;

  const results = new Array(jobs.length);
  let cursor = 0;
  const worker = async () => {
    while (cursor < jobs.length) {
      const index = cursor;
      cursor += 1;
      results[index] = await uploader(jobs[index].file);
    }
  };
  await Promise.all(Array.from({ length: Math.min(2, jobs.length) }, worker));

  let next = { ...draft };
  jobs.forEach((job, index) => {
    const url = results[index]?.url;
    if (job.type === 'product') {
      delete next._pendingImageFile;
      delete next._previewImageUrl;
      next.imageUrl = url;
      next.logosUrls = [url];
      next.imagePath = '';
      next.path = '';
      next.url = '';
      next.fileName = '';
      next.logoUrl = '';
      next.imageUrls = [];
      next.images = [];
      next.image = null;
      return;
    }
    next = updateProductOption(next, job.groupIndex, job.optionIndex, {
      imageUrl: url,
      logosUrls: [url],
      imagePath: '',
      path: '',
      url: '',
      fileName: '',
      logoUrl: '',
      imageUrls: [],
      images: [],
      image: null,
      _pendingImageFile: undefined,
      _previewImageUrl: undefined,
    });
  });
  return next;
};
